import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api, { imageapi } from "./Api/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const InnerDresses = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxDress = useSelector((state) => state.innerdress);

  const cartreduxdata = useSelector((state) => state.cart);
  const packagesreduxdata = useSelector((state) => state.packages);
  const personalisedreduxdata = useSelector((state) => state.personalised);
  const servicedata = useSelector((state) => state.services);
  const subservicedata = useSelector((state) => state.subservices);

  const [dressdata, setDressdata] = useState(reduxDress || null);

  const [price, setPrice] = useState(dressdata.price);
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [topen, setTOpen] = useState(false);
  const [tempString, setTempString] = useState();
  const [user, setUser] = useState();
  const [showPackages, setShowPackages] = useState(false);
  const [has, setHas] = useState(false);

  // ✅ Check if current product is in cart - REAL TIME
  const isInCart = () => {
    return cartreduxdata.some((item) => item.productid === dressdata?.id);
  };

  const { data: slugProduct } = useQuery(
    ["productBySlug", slug],
    () => api.get(`users/getproductbyslug/${slug}`),
    {
      select: (res) => res.data?.data,
      enabled: !!slug && !reduxDress?.id,
      onSuccess: (data) => {
        if (data) {
          let parsedImage = {};
          if (data.image) {
            try {
              parsedImage = JSON.parse(data.image);
            } catch (err) {
              console.log("Image JSON parse error", err);
            }
          }
          setDressdata({ ...data, jsonimage: parsedImage });
          setPrice(data.price);
        }
      },
    }
  );

  useEffect(() => {
    if (reduxDress && reduxDress.id) {
      setDressdata(reduxDress);
      setPrice(reduxDress.price);
    }
  }, [reduxDress]);

  const { data: packagedata, refetch } = useQuery(
    ["package"],
    () =>
      api.get(
        `users/getpackages/${
          dressdata?.gender ? dressdata?.gender : subservicedata?.name
        }`
      ),
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      select: (res) => res.data,
    }
  );

  useEffect(() => {
    window.scrollTo(0, 100);
  }, []);

  var total = 0;
  cartreduxdata.forEach((item) => {
    total += item.cartamount;
  });
  var packtotal = 0;

  packagesreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      packtotal += item.cartamount;
    }
  });
  var personalisedtotal = 0;
  personalisedreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      personalisedtotal += item.cartamount;
    }
  });

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, []);

  useEffect(() => {
    if (
      dressdata?.status ? true : servicedata?.type && servicedata.hasSubservices
    ) {
      setShowPackages(true);
    }
  }, [servicedata]);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("refresh"))) {
      window.location.reload();
      localStorage.setItem("refresh", JSON.stringify(0));
    }
  }, []);

  const mutationaddtocart = useMutation(
    (body) => {
      const headers = {
        headers: {
          "content-type": "application/json",
        },
      };
      return api.post("users/addtocart", body, headers);
    },
    {
      onError: (error, variables, context) => {
        console.log(error);
      },
      onSuccess: (data, variables, context) => {},
    }
  );

  const mutationpackage = useMutation(
    (body) => {
      const headers = {
        headers: {
          "content-type": "application/json",
        },
      };
      return api.post("users/addtopackage", body, headers);
    },
    {
      onError: (error, variables, context) => {
        console.log(error);
      },
      onSuccess: (data, variables, context) => {},
    }
  );

  const handleCal = (value, e) => {
    console.dir(e.target.value);
    console.log("see here", value.status);

    if (value.id == 1 && e.target.value == "55" && !has) {
      setPrice(dressdata.price + parseInt(e.target.value));
      setHas(true);
      var personalised = {};
      personalised["id"] = value.id;
      personalised["name"] = value.name;
      personalised["amount"] = 55;
      personalised["cartquantity"] = 1;
      personalised["productid"] = dressdata.id;

      dispatch({ type: "ADD_PERSONALISED", payload: personalised });

      return;
    } else {
      console.log("byr byr");
      setHas(false);
      dispatch({ type: "CLEAR_PERSONALISED" });
    }
    if (value.status) {
      packagedata.data.forEach((item) => {
        if (item.id == value.id) {
          item.status = 0;
        }
      });
    } else {
      packagedata.data.forEach((item) => {
        if (item.id == value.id) {
          item.status = 1;
        }
      });
    }
    var tempPackagedata = packagedata.data;
    var subPrice = 0;
    tempPackagedata.forEach((item) => {
      if (item.status) {
        subPrice += item.amount;
      }
    });
    var tempAmount = dressdata.price + parseInt(subPrice);
    setPrice(tempAmount);
    console.log(packagedata.data);
  };

  const handleCart = () => {
    var temppackagecart = [];
    packagedata.data &&
      packagedata.data.forEach((item, index) => {
        if (item.status) {
          var packageCart = {};
          packageCart["id"] = item.id;
          packageCart["name"] = item.name;
          packageCart["amount"] = item.amount;
          packageCart["cartquantity"] = 1;
          packageCart["productid"] = dressdata.id;
        }
        temppackagecart.push(packageCart);
      });
    var tempcart = {
      productid: dressdata.id,
      packages: JSON.stringify(temppackagecart),
      cartamount: dressdata.price,
      cartquantity: 1,
      price: dressdata.price,
      name: dressdata.name,
    };
    var cart = [tempcart];

    // ✅ REPLACE existing cart item if it exists, don't add quantity
    dispatch({ type: "REPLACE_CART_ITEM", payload: tempcart });
    handlePackages(JSON.parse(tempcart.packages), tempcart.packages);

    setTimeout(() => {
      setOpen(true);
      setTOpen(true);
    }, 1000);

    dispatch({ type: "CHECKOUT_STATUS", payload: 1 });
  };

  const handleClose = () => {
    setOpen(false);
    setTOpen(false);
    // ✅ Trigger refresh to update button state
    setRefresh(!refresh);
  };

  const handleAddtoCart = (item) => {
    setRefresh(!refresh);
    dispatch({ type: "ADD_TO_CART", payload: item });
  };

  const handlePackages = (packages, ustring) => {
    packages = packages?.map((item) => {
      if (item) {
        return { ...item, ustring: ustring };
      } else {
        return { ...item };
      }
    });
    console.log(packages);
    packages?.forEach((item) => {
      dispatch({ type: "ADD_PACKAGES", payload: item });
    });
    setRefresh(!refresh);
  };

  const handleDispatchPackages = (item, ustring) => {
    item = JSON.stringify(item);
    handlePackages(JSON.parse(`[${item}]`), ustring);
  };

  const handleMinusPackages = (packages, ustring) => {
    packages = packages?.map((item) => {
      if (item) {
        return { ...item, ustring: ustring };
      } else {
        return { ...item };
      }
    });
    console.log(packages);
    packages?.forEach((item) => {
      dispatch({ type: "MINUS_PACKAGES", payload: item });
    });
    setRefresh(!refresh);
  };

  const MinustoPackages = (item, ustring) => {
    item = JSON.stringify(item);
    handleMinusPackages(JSON.parse(`[${item}]`), ustring);
  };

  const handleDispatchPersonalised = (item) => {
    dispatch({ type: "ADD_PERSONALISED", payload: item });
    setRefresh(!refresh);
  };

  const handleMinusPersonalised = (item) => {
    dispatch({ type: "MINUS_PERSONALISED", payload: item });
    setRefresh(!refresh);
  };

  const handleShowPackages = (ustring) => {
    return packagesreduxdata?.map((item, index) => {
      return (
        <div key={index}>
          {item.ustring == ustring && item.cartquantity ? (
            <>
              {item.name} qty:- {item.cartquantity}{" "}
              <i
                className="fa-solid fa-plus"
                onClick={() => handleDispatchPackages(item)}
              ></i>
              <i
                className="fa-solid fa-minus"
                onClick={() => handleMinustoCart(item)}
              ></i>{" "}
            </>
          ) : (
            <></>
          )}
        </div>
      );
    });
  };

  const handleShowPackages2 = (packages, ustring) => {
    return packages.map((item, index, arr) => {
      return (
        <div key={index}>
          {item ? (
            <>
              <table className="cartMainAddTbl">
                <tbody>
                  <tr>
                    <td>{item?.name}</td>
                    <td>
                      £{"  "}
                      {
                        packagesreduxdata?.find(
                          (pitem) =>
                            pitem?.id == item?.id && pitem?.ustring == ustring
                        )?.cartamount
                      }
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-plus"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDispatchPackages(item, ustring);
                        }}
                      ></i>
                      {
                        packagesreduxdata?.find(
                          (pitem) =>
                            pitem?.id == item?.id && pitem?.ustring == ustring
                        )?.cartquantity
                      }
                      <i
                        className="fa-solid fa-minus"
                        onClick={(e) => {
                          e.stopPropagation();
                          MinustoPackages(item, ustring);
                        }}
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : (
            <></>
          )}
        </div>
      );
    });
  };

  const handleShowPersonalised = () => {
    return personalisedreduxdata.map((item, index, arr) => {
      return (
        <div key={index}>
          {item ? (
            <>
              <table className="cartMainAddTbl">
                <tbody>
                  <tr>
                    <td>{item.name}</td>
                    <b>Personalised </b>
                    <td>
                      £{"  "}
                      {
                        personalisedreduxdata?.find(
                          (pitem) => pitem?.id == item.id
                        )?.cartamount
                      }
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-plus"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDispatchPersonalised(item);
                        }}
                      ></i>
                      {
                        personalisedreduxdata?.find(
                          (pitem) => pitem?.id == item.id
                        )?.cartquantity
                      }
                      <i
                        className="fa-solid fa-minus"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMinusPersonalised(item);
                        }}
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : (
            <></>
          )}
        </div>
      );
    });
  };

  const handleSubmitData = () => {
    navigate("/details");
  };

  const handleMinustoCart = (item) => {
    var packclear = { productid: item.productid, ustring: item.packages };
    dispatch({ type: "MINUS_TO_CART", payload: item });
    dispatch({ type: "MINUS_PACKAGES_WITH_CART", payload: packclear });
    setRefresh(!refresh);
  };

  // ✅ Handle delete cart item with refresh
  const handleDeleteCartItem = (item) => {
    dispatch({ type: "CLEAR_SINGLE_CART_ITEM", payload: item });

    var packclear = { productid: item.productid, ustring: item.packages };
    dispatch({ type: "CLEAR_PACKAGES_FOR_PRODUCT", payload: packclear });

    if (cartreduxdata.length === 1) {
      dispatch({ type: "CLEAR_PERSONALISED" });
      setHas(false);
    }

    setRefresh(!refresh);
  };

  // ✅ Handle quantity input change with proper validation
  const handleQuantityChange = (item, newQty) => {
    const qty = parseInt(newQty);

    // If empty or invalid, don't update (will revert to original)
    if (newQty === "" || isNaN(qty)) {
      return;
    }

    // Validate quantity (1-50)
    if (qty < 1 || qty > 50) {
      return;
    }

    const currentQty = item.cartquantity;
    const difference = qty - currentQty;

    if (difference > 0) {
      for (let i = 0; i < difference; i++) {
        handleAddtoCart(item);
      }
    } else if (difference < 0) {
      const itemsToRemove = Math.min(Math.abs(difference), currentQty - 1);
      for (let i = 0; i < itemsToRemove; i++) {
        handleMinustoCart(item);
      }
    }
  };

  const CartModal = (props) => {
    // ✅ Check if cart is empty
    const isCartEmpty = cartreduxdata.length === 0;

    return (
      <Modal
        className="basketModalSec"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Your Basket
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {isCartEmpty ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <p>Your cart is empty</p>
              </div>
            ) : (
              <table className="cartMainTbl">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cartreduxdata?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item.name}

                          {handleShowPackages2(
                            JSON.parse(item.packages),
                            item.packages
                          )}

                          {has ? handleShowPersonalised() : <></>}
                        </td>
                        <td>
                          <div className="qtyInput">
                            <i
                              className="fa-solid fa-plus"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (item.cartquantity < 50) {
                                  handleAddtoCart(item);
                                }
                              }}
                              style={{
                                cursor:
                                  item.cartquantity >= 50
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: item.cartquantity >= 50 ? 0.5 : 1,
                              }}
                            ></i>
                            <input
                              type="number"
                              value={item.cartquantity}
                              min="1"
                              max="50"
                              onChange={(e) =>
                                handleQuantityChange(item, e.target.value)
                              }
                              onClick={(e) => e.stopPropagation()}
                              onFocus={(e) => {
                                // ✅ Select all text when focused
                                e.target.select();
                              }}
                              onBlur={(e) => {
                                // ✅ If empty or invalid, revert to original value
                                if (
                                  e.target.value === "" ||
                                  parseInt(e.target.value) < 1
                                ) {
                                  e.target.value = item.cartquantity;
                                }
                              }}
                              onKeyDown={(e) => {
                                // Prevent negative, decimal, and special characters
                                if (
                                  e.key === "-" ||
                                  e.key === "e" ||
                                  e.key === "E" ||
                                  e.key === "+" ||
                                  e.key === "."
                                ) {
                                  e.preventDefault();
                                }
                                // Prevent typing 0 at the start
                                if (e.key === "0" && e.target.value === "") {
                                  e.preventDefault();
                                }
                              }}
                              style={{
                                width: "60px",
                                textAlign: "center",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "5px",
                                margin: "0 5px",
                                fontSize: "14px",
                              }}
                            />
                            <i
                              className="fa-solid fa-minus"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (item.cartquantity > 1) {
                                  handleMinustoCart(item);
                                }
                              }}
                              style={{
                                cursor:
                                  item.cartquantity <= 1
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: item.cartquantity <= 1 ? 0.5 : 1,
                              }}
                            ></i>
                          </div>
                        </td>
                        <td>£{parseFloat(item.cartamount).toFixed(2)}</td>
                        <td>
                          <i
                            className="fa-solid fa-trash"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteCartItem(item);
                            }}
                            style={{
                              cursor: "pointer",
                              color: "#dc3545",
                              fontSize: "18px",
                              transition: "color 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.color = "#a02622")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.color = "#dc3545")
                            }
                            title="Remove from cart"
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!isCartEmpty && (
            <div className="cartModalAmt">
              <h4>
                <b>Product Price:</b> £{parseFloat(total).toFixed(2)}
              </h4>
              <h4>
                <b>Grand Total:</b> £
                {(
                  parseFloat(total) +
                  parseFloat(packtotal) +
                  parseFloat(personalisedtotal)
                ).toFixed(2)}
              </h4>
            </div>
          )}
          <div className="btnSec">
            <Button onClick={props.onHide}>Close</Button>
            <Button
              variant="success"
              onClick={handleSubmitData}
              disabled={isCartEmpty}
              style={{
                opacity: isCartEmpty ? 0.5 : 1,
                cursor: isCartEmpty ? "not-allowed" : "pointer",
              }}
            >
              Proceed to Checkout
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Helmet>
        <title>{dressdata.meta_title || "South London Removals"}</title>
        <meta
          name="title"
          content={dressdata.meta_title || "South London Removals"}
        />
        <meta
          name="keywords"
          content={dressdata.meta_keywords || "South London Removals"}
        />
        <meta
          name="description"
          content={dressdata.meta_description || "South London Removals"}
        />
      </Helmet>

      <div>
        <div className="addcart-section section">
          <div className="container">
            <div className="row">
              <div className="col-sm-4">
                <div className="cart-product">
                  <img
                    src={
                      dressdata
                        ? `${imageapi}images/${dressdata?.jsonimage?.picture0}`
                        : ``
                    }
                    alt="image"
                  />
                </div>
              </div>
              <div className="col-sm-8">
                <div className="productDetailSec">
                  <h2>{dressdata && dressdata.name}</h2>

                  {dressdata.id == 70 ? (
                    <>
                      <p>
                        This removal kit is suitable for most small house moves
                        and flat moves, and is set at a great price for the end
                        consumer. It comprises a mixture of 40 cardboard boxes
                        (both single and double wall) as well as a mixture of
                        the packaging materials required during a move. The
                        exact items the kit comprises are listed below:
                      </p>
                    </>
                  ) : (
                    <></>
                  )}

                  {dressdata.id == 71 ? (
                    <>
                      <p>
                        This removal kit is suitable for most 2-3 bedroom house
                        moves, and is set at a great price for the end consumer.
                        It comprises a mixture of 60 cardboard boxes (both
                        single and double wall) as well as a mixture of the
                        packaging materials required during a move. The exact
                        items the kit comprises are listed below:
                      </p>
                    </>
                  ) : (
                    <></>
                  )}

                  {dressdata.id == 72 ? (
                    <>
                      <p>
                        This removal kit is suitable for most large house moves
                        (4-5 bedrooms) and is set at a great price for the end
                        consumer. It comprises a mixture of 100 cardboard boxes
                        (both single and double wall), as well as a mixture of
                        the packaging materials required during a move. The
                        exact items the kit comprises are listed below:
                      </p>
                    </>
                  ) : (
                    <></>
                  )}

                  <h3>£{price}</h3>
                  {dressdata.id == 70 ? (
                    <>
                      <div>
                        <p style={{ fontWeight: "bold" }}>Size:</p>
                        <p>15 x Small Double Wall Boxes – 458x305x304mm </p>
                        <p>15 x Medium Double Wall Boxes - 458x458x305mm </p>
                        <p>10 x Large Double Wall Boxes – 458x458x508mm</p>
                        <p>1 x Wardrobe box - 508x458x1220mm</p>
                      </div>
                      <div>
                        <p style={{ fontWeight: "bold" }}>
                          Half pack kitchen white paper
                        </p>
                        <p>1 x Small Bubble Wrap</p>
                        <p>1 x Shrink Wrap</p>
                        <p>4 x Brown Packing Tapes</p>
                        <p>1 x Fragile Tape</p>
                        <p>1 x Marker Pen</p>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {dressdata.id == 71 ? (
                    <>
                      <div>
                        <p style={{ fontWeight: "bold" }}>Size:</p>
                        <p>20 x Small Double Wall Boxes – 458x305x304mm</p>
                        <p>20 x Medium Double Wall Boxes - 458x458x305mm</p>
                        <p>20 x Large Double Wall Boxes – 458x458x508mm</p>
                        <p>2 x Wardrobe Boxes - 508x458x1220mm</p>
                        <p>
                          Full pack kitchen white paper (430x510mm, 10.0 kg per
                          pack)
                        </p>
                        <p>1 x Small Bubble Wrap - 500X100mm</p>
                        <p>1 x Shrink Wrap -400mmx250m</p>
                        <p>6 x Brown Packing Tapes</p>
                        <p>1 x Fragile Tape</p>
                        <p>10 x Heavy-Duty Bin Bags</p>
                        <p>1 x Marker Pen</p>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {dressdata.id == 72 ? (
                    <>
                      <div>
                        <p style={{ fontWeight: "bold" }}>Size:</p>
                        <p>30 x Small Double Wall Boxes – 458x305x304mm</p>
                        <p>45 x Medium Double Wall Boxes - 458x458x305mm</p>
                        <p>25 x Large Double Wall Boxes – 458x458x508mm</p>
                        <p>3 x Wardrobe Boxes - 508x458x1220mm</p>
                      </div>
                      <div>
                        <p style={{ fontWeight: "bold" }}>
                          Full pack kitchen white paper (430x510mm, 10.0 kg per
                          pack)
                        </p>
                        <p>1 x Medium Bubble Wrap - 750x100mm</p>
                        <p>2 x Shrink Wrap -400mmx250m</p>
                        <p>8 x Brown Packing Tapes</p>
                        <p>2 x Fragile Tape</p>
                        <p>20 x Bin Bags</p>
                        <p>1 x Marker Pen</p>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {dressdata.id == 70 ||
                  dressdata.id == 71 ||
                  dressdata.id == 72 ? (
                    <></>
                  ) : (
                    <p style={{ fontWeight: "bold" }}>
                      Size: {dressdata.description}
                    </p>
                  )}

                  <div className="row">
                    {showPackages &&
                      packagedata &&
                      packagedata.data.map((item, index, arr) => {
                        return (
                          <div className="col-sm-6 mt-4" key={index}>
                            <label>
                              {item.name} (+£{item.amount})
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) => handleCal(item, e)}
                            >
                              <option>No</option>
                              <option>Standard (+£{item.amount})</option>
                              {item.id == 1 && (
                                <option value="55">
                                  {" "}
                                  Personalised (+£55){" "}
                                </option>
                              )}
                            </select>
                          </div>
                        );
                      })}

                    <div className="col-sm-6 mt-1">
                      {/* ✅ REAL TIME CHECK - Always check current Redux state */}
                      {isInCart() ? (
                        <Link to="/cart">
                          <button className="btn2 mt-4">Go to cart</button>
                        </Link>
                      ) : (
                        <button
                          className="btn2 mt-4"
                          onClick={() => handleCart()}
                        >
                          Add to cart
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {topen ? <CartModal show={open} onHide={() => handleClose()} /> : <></>} */}
      </div>
    </>
  );
};

export default InnerDresses;
